import { render, staticRenderFns } from "./SettlementFiles.vue?vue&type=template&id=5cf3ca00&scoped=true"
import script from "./SettlementFiles.vue?vue&type=script&lang=js"
export * from "./SettlementFiles.vue?vue&type=script&lang=js"
import style0 from "./SettlementFiles.vue?vue&type=style&index=0&id=5cf3ca00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf3ca00",
  null
  
)

export default component.exports